// extracted by mini-css-extract-plugin
export default {"acceptedCards":"AcceptedCards_acceptedCards__wLyiR","card":"AcceptedCards_card__OH5PS","amex":"AcceptedCards_amex__jSjdQ","cardImage":"AcceptedCards_cardImage__KMfkl"};